import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { PaymentsStore } from "../types/Store/PaymentsStore.types";
import apiPaymentsClient from "../api/api.payments";
import { useAuthStore } from "./auth.store";
import dayjs from "dayjs";
import { throwError } from "../hooks/useErrorHandler";

export const usePaymentsStore = create<PaymentsStore>()(
    persist(
        (set, get) => ({
            lastPayment: [],
            lastPaymentAmount: 0,
            payments: [],
            transactions: [],
            total_transactions: 0,
            total_payments: 0,
            balance: 0,

            getLastPayments: async () => {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    const { data } = await apiPaymentsClient.get(
                        "/api/v1/operations/last-period?personal_account_id=" +
                            activeAccount,
                    );
                    console.log("Last Payments data", data);
                    set({
                        lastPayment: data.invoices.invoices,
                        lastPaymentAmount: data.total_amount,
                        balance: data.balance,
                    });
                } catch (error) {
                    console.log(error);
                } finally {
                }
            },

            getPeriodPayments: async (
                offset = 0,
                month = null,
                order = "DESC",
            ) => {
                try {
                    const d = month ? dayjs("01 " + month) : dayjs();
                    const { activeAccount } = useAuthStore.getState();
                    const { data } = await apiPaymentsClient.get(
                        "/api/v1/operations/payments?personal_account_id=" +
                            activeAccount +
                            "&limit=12" +
                            "&sort_order=" +
                            order +
                            "&offset=" +
                            offset +
                            (month
                                ? month &&
                                  "&date_from=" +
                                      new Date(
                                          Date.UTC(
                                              d.year(),
                                              d.month(),
                                              1,
                                              0,
                                              0,
                                              0,
                                          ),
                                      ).toISOString() +
                                      "&date_to=" +
                                      new Date(
                                          Date.UTC(
                                              d.year(),
                                              d.month() + 1,
                                              0,
                                              23,
                                              59,
                                              59,
                                          ),
                                      ).toISOString()
                                : ""),
                    );
                    console.log("Payments data", data);
                    set({
                        payments: data.months,
                        total_payments: data.total_count_periods,
                    });

                    return data;
                } catch (error) {
                    console.log(error);
                    location.href = "/";
                    return null;
                }
            },

            getTransactions: async (offset = 0, sort = "DESC") => {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    const { data } = await apiPaymentsClient.get(
                        "/api/v1/operations/transactions?personal_account_id=" +
                            activeAccount +
                            "&offset=" +
                            offset +
                            "&sort_order=" +
                            sort,
                    );
                    console.log("Transactions data", data);
                    set({
                        transactions: data.transactions,
                        total_transactions: data.total_count,
                    });
                } catch (error) {
                    console.log(error);
                } finally {
                }
            },

            async getInvoicePaymentInfo(invoice_id) {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    const { data, status } = await apiPaymentsClient.get(
                        "/api/v1/operations/invoices/payment-info?personal_account_id=" +
                            activeAccount +
                            "&invoice_id=" +
                            invoice_id,
                    );

                    if (status == 200 || status == 201) return data;
                    else return null;
                } catch (error) {
                    throwError(error);
                    return null;
                }
            },

            async getRecipientInfo(invoice_id) {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    const { data, status } = await apiPaymentsClient.get(
                        "/api/v1/operations/invoices/receipt?personal_account_id=" +
                            activeAccount +
                            "&invoice_id=" +
                            invoice_id,
                    );

                    if (status == 200 || status == 201) return data.receipt_url;
                    else return null;
                } catch (error) {
                    throwError(error);
                    return null;
                }
            },
        }),
        {
            name: "payments-store", // ключ в localStorage
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                payments: state.payments,
                transactions: state.transactions,
            }),
        },
    ),
);
